import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './App.css';
import Home from './Home';
import MaryStory from './MaryStory';
import ScrollToTop from './ScrollToTop';

// ---------- Lightweight pages for Stripe redirects ----------
const SuccessPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <main className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="text-green-500 text-6xl mb-4">✓</div>
        <h1 className="text-3xl font-black text-gray-900 mb-3">Order Successful</h1>
        <p className="text-gray-600 mb-6">
          Thank you! We’ve emailed your receipt and will notify you with shipping updates.
        </p>
        <button
          onClick={() => navigate('/')}
          className="rounded-full bg-[#213B5C] text-white px-6 py-3 font-semibold hover:bg-[#1a2f4a] transition"
        >
          Back to Home
        </button>
      </div>
    </main>
  );
};

const CancelPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <main className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        <div className="text-red-500 text-6xl mb-4">!</div>
        <h1 className="text-3xl font-black text-gray-900 mb-3">Payment Canceled</h1>
        <p className="text-gray-600 mb-6">
          No charge was made. You can try again anytime. If you need help, contact us and we’ll get you set up.
        </p>
        <button
          onClick={() => navigate('/')}
          className="rounded-full border border-[#213B5C] text-[#213B5C] px-6 py-3 font-semibold hover:bg-[#213B5C] hover:text-white transition"
        >
          Back to Home
        </button>
      </div>
    </main>
  );
};

// ---------- App Shell ----------
const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/mary-story" element={<MaryStory />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/cancel" element={<CancelPage />} />
      </Routes>
      <Analytics />
    </Router>
  );
};

export default App;
